import { typography } from "@iewccouk/Utilities/styleguide/Typography";
import { colorStrings, mediaQueriesBP } from "@iewccouk/Utilities/variables";
import { headerLinkListStyles as styles } from "@insite/content-library/Widgets/Header/HeaderLinkList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.headerLinkListWrapper = {
    ...styles.headerLinkListWrapper,
    css: css`
        display: flex;
        gap: 40px;
        margin-right: 0;
        padding: 0;

        &&&& * {
            color: ${getColor(colorStrings.textMain)};
        }
    `,
};

styles.link = {
    ...styles.link,
    typographyProps: {
        ...styles.link?.typographyProps,
        ...typography.h5,
        variant: "h5",
        color: colorStrings.textMain,
        css: css`
            margin: 0;
            text-transform: uppercase;
        `,
    },
};
